import React from 'react';
import PropTypes from 'prop-types';
import ContentSidebarStyles from './ContentSidebar.styled';
import { useInView } from 'react-intersection-observer';
import theme from '../../styles/theme';

const ContentSidebar = ({
  sidebar = null,
  sidebarWidth = theme.maxWidths.sidebar,
  children,
  sidebarFirstOnMobile = false,
  sidebarFirst = false,
  isAnimated = true,
  background,
}) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <ContentSidebarStyles
      sidebarWidth={sidebarWidth}
      sidebarFirst={sidebarFirst}
      sidebarFirstOnMobile={sidebarFirstOnMobile}
      ref={ref}
      className={`block-content_sidebar ${isAnimated && 'isAnimated'} ${
        inView && 'active'
      }`}
      background={background}
    >
      <div className='inner'>
        <div className='content'>{children}</div>
        <div className='sidebar'>{sidebar}</div>
      </div>
    </ContentSidebarStyles>
  );
};

ContentSidebar.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  sidebar: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isAnimated: PropTypes.bool,
};

export default ContentSidebar;
